<template>
  <v-tab-item>
    <v-data-table :items="booths" :headers="headers">
      <template v-slot:item.category="{ item }">
        K {{ item.category }}
      </template>
      <template v-slot:item.occupied="{ item }">
        <span
          :class="
            `overline mb-2 booth-card-${occupiedIndexToStr(item.occupied)}`
          "
          >{{ $t(`view.${occupiedIndexToStr(item.occupied)}`) }}</span
        >
      </template>
      <template v-slot:item.size="{ item }">{{ item.size }} m²</template>
      <template v-slot:item.vendorName="{ item }">
        <div
          v-if="item.occupied == 0 && !selectedBoothIds.includes(item._id)"
          class="text-uppercase cta-button bg-red cta-btn-table"
        >
          <a @click="reserve(item)">{{ $t("view.reserve") }}</a>
        </div>
        <template v-if="item.occupied == 2">
          <a
            @click="currentExhibitorUserId = item.user_id"
            v-if="item.user_id"
            >{{ item.vendorName }}</a
          >
          <a :href="item.vendorUrl" target="_blank" rel="noopener" v-else>{{
            item.vendorName
          }}</a>
          <span
            class="ml-1"
            v-for="additionalExhibitor in item.additionalExhibitors || []"
            :key="additionalExhibitor.id"
          >
            <a
              :href="additionalExhibitor.vendorUrl"
              target="_blank"
              rel="noopener"
            >
              {{ additionalExhibitor.vendorName }}
            </a>
          </span>
        </template>
      </template>
    </v-data-table>
    <VirtualExhibitionDialog :userId="currentExhibitorUserId" />
  </v-tab-item>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { i18n } from "@/plugins/i18n";
import VirtualExhibitionDialog from "../VirtualExhibitionDialog.vue";

export default {
  props: ["booths"],
  components: {
    VirtualExhibitionDialog,
  },
  data: () => ({
    currentExhibitorUserId: null,
    headers: [
      {
        text: i18n.t("form.fields.booth"),
        align: "start",
        sortable: true,
        value: "title",
        sort: (a, b) => {
          if (isNaN(a) || isNaN(b)) {
            return a < b ? -1 : 1;
          }
          return +a < +b ? -1 : 1;
        },
      },
      {
        text: i18n.t("form.category"),
        align: "start",
        sortable: true,
        value: "category",
      },
      {
        text: i18n.t("form.size"),
        align: "start",
        sortable: true,
        value: "size",
      },
      {
        text: i18n.t("form.occupation"),
        align: "start",
        sortable: true,
        value: "occupied",
      },
      {
        text: i18n.t("form.fields.vendorName"),
        align: "start",
        sortable: true,
        value: "vendorName",
      },
    ],
  }),
  methods: {
    ...mapActions(["addSelectedBoothId"]),
    reserve(item) {
      this.addSelectedBoothId(item._id);
      const element = document.getElementById("exhibition-contact-form");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    occupiedIndexToStr(index) {
      if (index === 0) {
        return "free";
      }
      if (index === 1) {
        return "reserved";
      }
      if (index === 2) {
        return "occupied";
      }
    },
  },
  computed: {
    ...mapGetters(["selectedBoothIds"]),
  },
};
</script>

<style lang="scss" scoped>
.cta-btn-table {
  height: 35px !important;
  width: 160px;
}
</style>
